import { render, staticRenderFns } from "./reservation-info.vue?vue&type=template&id=aa72778c&scoped=true"
import script from "./reservation-info.vue?vue&type=script&lang=js"
export * from "./reservation-info.vue?vue&type=script&lang=js"
import style0 from "./reservation-info.vue?vue&type=style&index=0&id=aa72778c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa72778c",
  null
  
)

export default component.exports